import React from "react" ;
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {UserTypeFilters, UserTypeTitles} from "root/DataFunctions/Constants";
import {useRecoilValue} from "recoil";
import {teamNameAtom} from "root/recoil/teamName";

const TeamAppBodyHeader = (props) =>
{
    const {search} = useLocation();

    const team_name = useRecoilValue(teamNameAtom);
    const {pathname} = useLocation();

    const queryParams = queryString.parse(search);
    const user_filter_type = queryParams.user_type === undefined ? UserTypeFilters.STAFF : queryParams.user_type;

    const buildHeader = (sub_header) => {
        return <h4 className="title">{team_name.name} - {sub_header}</h4>;
    }

    const buildConnectionsHeader = (header, sub_header) => {
        return <h4 className="title">{header} {sub_header}</h4>;
    }

    const titleFromType = ( type ) =>
    {
        switch ( type )
        {
            case UserTypeFilters.STAFF:
                return UserTypeTitles.STAFF ;
            case UserTypeFilters.CHILDREN:
                return UserTypeTitles.CHILDREN ;
            case UserTypeFilters.FOSTER_CARERS:
                return UserTypeTitles.FOSTER_CARERS ;
            case UserTypeFilters.CONNECTED_CARERS:
                return UserTypeTitles.CONNECTED_CARERS ;
            case UserTypeFilters.FOREVER_PARENTS:
                return UserTypeTitles.FOREVER_PARENTS ;
            case UserTypeFilters.BIRTH_PARENTS:
                return UserTypeTitles.BIRTH_PARENTS ;
            case UserTypeFilters.PROFESSIONALS:
                return UserTypeTitles.PROFESSIONALS ;
            case UserTypeFilters.OTHERS:
                return UserTypeTitles.OTHERS ;
            default:
                return UserTypeTitles.STAFF ;

        }

    }

    const displayHeader = () =>
    {
        if (pathname.includes('/dashboard'))
        {
            return buildHeader('Dashboard');
        }
        else if (pathname.includes('/connections'))
        {
            const user_name_string = 'for ' + queryParams.name;

            return buildConnectionsHeader('Connections', user_name_string);
        }
        else if (pathname.includes('/details'))
        {
            return buildHeader('Details');
        }
        else if (pathname.includes('/users'))
        {
            return buildHeader(titleFromType( user_filter_type ));
        }
        else
        {
            return buildHeader(titleFromType( user_filter_type ));
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">
            <div className="team-menu-item">
                <span>{displayHeader()}</span>
            </div>
        </div>
    );
}

export default TeamAppBodyHeader;
